exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pass-rules .card-body[data-v-68b6d0b9]{padding:0}.pass-rules .card-body p[data-v-68b6d0b9]{text-align:left;margin:0;padding:0;font-size:.6em}", ""]);

// exports
